import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Close from '@/images/Close.svg';
import { shakeAnimation } from '@/utils/utils';
import styled from '@emotion/styled';
import { IconButton, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
    className?: string;
    icon: ReactNode;
    title?: string;
    content: ReactNode;
    show: boolean;
    onClose?: () => void;
}

const ToastContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 0.8rem;
    animation: ${shakeAnimation} 0.5s;
    align-items: flex-start;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
`;

const Message = styled.div`
    color: '#FFFEFD';
    font-size: 1.4rem;
    line-height: 143%;
`;

const CloseButton = styled(IconButton)`
    margin: 4px 4px 4px auto;
`;

export const InlineToast = ({ icon, title, content, className, show, onClose }: Props) => {
    if (!show) {
        return <></>;
    }

    return (
        <ToastContainer className={className}>
            {icon}
            <ContentContainer>
                <Typography variant="h4">{title}</Typography>
                <Message>{content}</Message>
            </ContentContainer>
            {!!onClose && (
                <CloseButton onClick={onClose}>
                    <MaskedIcon src={Close} size="16px" />
                </CloseButton>
            )}
        </ToastContainer>
    );
};
